import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyView"] */ "D:\\FekerTech\\Shahen Website New\\src\\sections\\privacy-policy\\view\\privacy-policy-view.jsx");
